export const TAG_COLOR_CLASSES = {
  yellow: "tag-yellow",
  red: "tag-red",
  orange: "tag-orange",
  blue: "tag-blue",
  purple: "tag-purple",
  green: "tag-green",
  pink: "tag-pink",
  gray: "tag-gray",
};

export function tagClass(color) {
  return TAG_COLOR_CLASSES[color] || "tag-gray";
}

export function resolveTags(tagIds, tagList) {
  const ids = tagIds || [];
  return (tagList || [])
    .filter(t => ids.includes(t.val))
    .map(t => ({ val: t.val, label: t.label, desc: t.desc, color: t.color }));
}

// Whitelist only: the backend writes just the fields sent, so spreading the
// whole (possibly stale) list row would overwrite other columns.
export function patientUpdatePayload(patient, tagIds) {
  const p = patient || {};
  ["firstNameTh", "lastNameTh", "mobile", "allergic"].forEach(k => {
    if (p[k] === undefined) throw new Error("PATIENT-INCOMPLETE");
  });
  return {
    id: p.id,
    firstNameTh: p.firstNameTh ?? "",
    lastNameTh: p.lastNameTh ?? "",
    mobile: p.mobile ?? "",
    allergic: p.allergic ?? "",
    tagIds,
  };
}
